import { defaultOptions } from '@primevue/core/config';
import { definePreset } from '@primevue/themes';
import Aura from '@primevue/themes/aura';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';

import { i18n } from '@/shared/i18n';

import type { App } from 'vue';

const bookingPreset = definePreset(Aura, {
	components: {
		dialog: { header: { padding: '0.75rem 1.25rem' } },
		tag: {
			padding: `${0.25 * (14 / 16)}rem ${0.5 * (14 / 16)}rem`
		}
	}
});

export const initQuickQuoteApp = (app: App): void => {
	app.use(createPinia());
	app.use(i18n);
	app.use(PrimeVue, {
		ripple: true,
		theme: {
			options: {
				cssLayer: false,
				darkModeSelector: 'none'
			},
			preset: bookingPreset
		},
		locale: {
			...defaultOptions.locale,
			dateFormat: 'M d, yy'
		},
		zIndex: {
			menu: 11100,
			modal: 11000,
			overlay: 10000,
			tooltip: 11101
		}
	});
	app.use(ToastService);
	app.directive('tooltip', Tooltip);
};
